import { useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtErr } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { toast } from "sonner";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(fmtErr(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <AuthShell title="Reset password" subtitle="We'll email you a reset link.">
      {sent ? (
        <div className="rounded-xl bg-emerald-50 border border-emerald-200 p-5 text-emerald-800" data-testid="forgot-confirm">
          If that email is registered, a reset link has been sent. Check your inbox.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="w-full px-4 py-3 rounded-xl border border-stone-200 outline-none focus:border-[var(--friib)]" />
          <button disabled={busy} data-testid="forgot-submit" className="w-full py-3.5 rounded-full font-bold text-white disabled:opacity-60" style={{ background: "var(--friib)" }}>{busy ? "Sending…" : "Send reset link"}</button>
        </form>
      )}
      <p className="mt-6 text-center text-sm text-stone-500"><Link to="/login" className="font-bold text-[var(--friib)]">Back to sign in</Link></p>
    </AuthShell>
  );
}
